import styled from "styled-components";

export const ModalControl = styled.a`
    display: inline-flex;
    vertical-align: top;
    position: absolute;
`;

export const Content = styled.div`
    margin: auto 3.438rem;
    margin-bottom: 7.625rem;
`;

export const FormField = styled.div`
    margin: 1rem 0;
`;

export const Action = styled.div`
    margin: 2.5rem 4.375rem 2.5rem 0;
    text-align: right;
    > button.MuiButton-root {
        margin-left: 1rem;
        margin-right: 0;
        min-width: 8.75rem;
        height: 2.625rem;
    }
    > button.MuiButton-root:hover {
        opacity: 0.75;
        box-shadow: none;
        background-color: ${globalThis.config.colors.black};
    }

    position: absolute;
    bottom: 0;
    right: 0;
`;

export const LoaderWrapper = styled.div`
    text-align: center;
    margin-top: 4rem;
`;
